export default __webpack_public_path__ + "static/certificate-pet-vertical-d26cd6b3ff418790f11ba2c2f98d7297.png";